var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("back-bar-default-section", {
    staticClass: "menu--section-back_bar_drinks",
    attrs: {
      menu: _vm.menu,
      section: _vm.section,
      "section-modifier": _vm.sectionModifier,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }